import { ShopifyProduct } from "../../utils/interfaces";

export interface TitleBadgeProps {
    handle: string;
    shineAssets: Record<string, string>;
}

export interface SelectedOption {
    name: string;
    value: string;
}

export interface ProductSelection {
    options?: SelectedOption[];
    quantity?: number | "";
    variantId?: number | null;
    finish?: string;
}

export interface ProductProperties {
    customColour?: string;
    finish?: string;
    "Custom Title"?: string;
}

export interface ColorStock {
    color: string;
    stock: string;
}

export interface TitleBadgeState {
    productLoaded: boolean;
    product?: ShopifyProduct;
    selection?: ProductSelection;
    properties?: ProductProperties;
    colorStock?: ColorStock[] | null;
}

export enum Finish {
    Silver = 'Silver',
    Gold = 'Gold',
    Black = 'Black',
    Bronze = 'Bronze',
}

export enum Properties {
    CustomTitle = "Custom Title",
}

export enum OptionName {
    Style = 'Style',
    Colour = 'Colour',
}